let wasm;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

let WASM_VECTOR_LEN = 0;

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat32ArrayMemory0 = null;

function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}
/**
 * @param {string} cheat_id
 * @param {string} cheat
 * @returns {string | undefined}
 */
export function registerGamesharkCheat(cheat_id, cheat) {
    const ptr0 = passStringToWasm0(cheat_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(cheat, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.registerGamesharkCheat(ptr0, len0, ptr1, len1);
    let v3;
    if (ret[0] !== 0) {
        v3 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v3;
}

export function resetEmulator() {
    wasm.resetEmulator();
}

export function stepUntilNextAudioBuffer() {
    wasm.stepUntilNextAudioBuffer();
}

/**
 * @param {Uint8Array} bytes
 */
export function esp8266PushResponse(bytes) {
    const ptr0 = passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.esp8266PushResponse(ptr0, len0);
}

export function enableEsp8266() {
    wasm.enableEsp8266();
}

/**
 * @param {string} cheat
 * @returns {string | undefined}
 */
export function validateGamegenieCode(cheat) {
    const ptr0 = passStringToWasm0(cheat, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validateGamegenieCode(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {Uint8Array} data
 * @returns {string | undefined}
 */
export function applySaveState(data) {
    const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.applySaveState(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {string} cheat_id
 * @param {string} cheat
 * @returns {string | undefined}
 */
export function registerGamegenieCheat(cheat_id, cheat) {
    const ptr0 = passStringToWasm0(cheat_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(cheat, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.registerGamegenieCheat(ptr0, len0, ptr1, len1);
    let v3;
    if (ret[0] !== 0) {
        v3 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v3;
}

/**
 * @returns {SaveStateResult}
 */
export function encodeSaveState() {
    const ret = wasm.encodeSaveState();
    return SaveStateResult.__wrap(ret);
}

export function esp8266DiscardPendingCommand() {
    wasm.esp8266DiscardPendingCommand();
}

/**
 * @param {string} key_code
 */
export function releaseKey(key_code) {
    const ptr0 = passStringToWasm0(key_code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.releaseKey(ptr0, len0);
}

/**
 * @param {string} cheat
 * @returns {string | undefined}
 */
export function validateGamesharkCode(cheat) {
    const ptr0 = passStringToWasm0(cheat, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validateGamesharkCode(ptr0, len0);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * @param {Uint8Array} rom_buffer
 * @param {EmulatorSettings} settings
 * @returns {RomMetadataResult}
 */
export function initializeEmulator(rom_buffer, settings) {
    const ptr0 = passArray8ToWasm0(rom_buffer, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(settings, EmulatorSettings);
    var ptr1 = settings.__destroy_into_raw();
    const ret = wasm.initializeEmulator(ptr0, len0, ptr1);
    return RomMetadataResult.__wrap(ret);
}

/**
 * @param {string} key_code
 */
export function pressKey(key_code) {
    const ptr0 = passStringToWasm0(key_code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.pressKey(ptr0, len0);
}

/**
 * @param {string} cheat_id
 */
export function unregisterCheat(cheat_id) {
    const ptr0 = passStringToWasm0(cheat_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.unregisterCheat(ptr0, len0);
}

const EmulatorSettingsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_emulatorsettings_free(ptr >>> 0, 1));

export class EmulatorSettings {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        EmulatorSettingsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_emulatorsettings_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get audioSampleRate() {
        const ret = wasm.emulatorsettings_audioSampleRate(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {string} mode
     * @param {number} audio_sample_rate
     */
    constructor(mode, audio_sample_rate) {
        const ptr0 = passStringToWasm0(mode, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.emulatorsettings_new(ptr0, len0, audio_sample_rate);
        this.__wbg_ptr = ret >>> 0;
        EmulatorSettingsFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string}
     */
    get mode() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.emulatorsettings_mode(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const RomMetadataFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rommetadata_free(ptr >>> 0, 1));

export class RomMetadata {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RomMetadata.prototype);
        obj.__wbg_ptr = ptr;
        RomMetadataFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RomMetadataFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rommetadata_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */
    get hasBattery() {
        const ret = wasm.rommetadata_hasBattery(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} title
     * @param {boolean} has_battery
     */
    constructor(title, has_battery) {
        const ptr0 = passStringToWasm0(title, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.rommetadata_new(ptr0, len0, has_battery);
        this.__wbg_ptr = ret >>> 0;
        RomMetadataFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string}
     */
    get title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.rommetadata_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const RomMetadataResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_rommetadataresult_free(ptr >>> 0, 1));

export class RomMetadataResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RomMetadataResult.prototype);
        obj.__wbg_ptr = ptr;
        RomMetadataResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RomMetadataResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rommetadataresult_free(ptr, 0);
    }
    /**
     * @param {string | null} [error]
     * @param {RomMetadata | null} [metadata]
     */
    constructor(error, metadata) {
        var ptr0 = isLikeNone(error) ? 0 : passStringToWasm0(error, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        let ptr1 = 0;
        if (!isLikeNone(metadata)) {
            _assertClass(metadata, RomMetadata);
            ptr1 = metadata.__destroy_into_raw();
        }
        const ret = wasm.rommetadataresult_new(ptr0, len0, ptr1);
        this.__wbg_ptr = ret >>> 0;
        RomMetadataResultFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string | undefined}
     */
    get error() {
        const ret = wasm.rommetadataresult_error(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {RomMetadata | undefined}
     */
    get metadata() {
        const ret = wasm.rommetadataresult_metadata(this.__wbg_ptr);
        return ret === 0 ? undefined : RomMetadata.__wrap(ret);
    }
}

const SaveStateResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_savestateresult_free(ptr >>> 0, 1));

export class SaveStateResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SaveStateResult.prototype);
        obj.__wbg_ptr = ptr;
        SaveStateResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SaveStateResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_savestateresult_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array | undefined}
     */
    get saveState() {
        const ret = wasm.savestateresult_saveState(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {string | null} [error]
     * @param {Uint8Array | null} [save_state]
     */
    constructor(error, save_state) {
        var ptr0 = isLikeNone(error) ? 0 : passStringToWasm0(error, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(save_state) ? 0 : passArray8ToWasm0(save_state, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.savestateresult_new(ptr0, len0, ptr1, len1);
        this.__wbg_ptr = ret >>> 0;
        SaveStateResultFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {string | undefined}
     */
    get error() {
        const ret = wasm.savestateresult_error(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
}

const WasmRTCStateFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmrtcstate_free(ptr >>> 0, 1));

export class WasmRTCState {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmRTCState.prototype);
        obj.__wbg_ptr = ptr;
        WasmRTCStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmRTCStateFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmrtcstate_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get milliseconds() {
        const ret = wasm.wasmrtcstate_milliseconds(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get base_timestamp() {
        const ret = wasm.wasmrtcstate_base_timestamp(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} milliseconds
     * @param {number} seconds
     * @param {number} minutes
     * @param {number} hours
     * @param {number} days
     * @param {number} base_timestamp
     * @param {boolean} halted
     * @param {boolean} day_carry
     */
    constructor(milliseconds, seconds, minutes, hours, days, base_timestamp, halted, day_carry) {
        const ret = wasm.wasmrtcstate_new(milliseconds, seconds, minutes, hours, days, base_timestamp, halted, day_carry);
        this.__wbg_ptr = ret >>> 0;
        WasmRTCStateFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {number}
     */
    get days() {
        const ret = wasm.wasmrtcstate_days(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get hours() {
        const ret = wasm.wasmrtcstate_hours(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */
    get halted() {
        const ret = wasm.wasmrtcstate_halted(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */
    get minutes() {
        const ret = wasm.wasmrtcstate_minutes(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get seconds() {
        const ret = wasm.wasmrtcstate_seconds(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */
    get day_carry() {
        const ret = wasm.wasmrtcstate_day_carry(this.__wbg_ptr);
        return ret !== 0;
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_advanceEsp8266Time_db539e8e79971d05 = function(arg0) {
        advanceEsp8266Time(arg0);
    };
    imports.wbg.__wbg_canPollEsp8266Command_831e4e3a66529c5c = function() {
        const ret = canPollEsp8266Command();
        return ret;
    };
    imports.wbg.__wbg_canvasRender_1978854a85fa06cd = function(arg0, arg1) {
        canvasRender(getArrayU8FromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_currentTimeMillis_01feb10bd795c4cc = function() {
        const ret = currentTimeMillis();
        return ret;
    };
    imports.wbg.__wbg_error_7534b8e9a36f1ab4 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_esp8266OnCommand_f97c51456f8b49ee = function(arg0, arg1) {
        esp8266OnCommand(getArrayU8FromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_loadRTCState_c3965667cc296bad = function(arg0, arg1) {
        const ret = loadRTCState(getStringFromWasm0(arg0, arg1));
        let ptr1 = 0;
        if (!isLikeNone(ret)) {
            _assertClass(ret, WasmRTCState);
            ptr1 = ret.__destroy_into_raw();
        }
        return ptr1;
    };
    imports.wbg.__wbg_loadRam_73c740c932e79a4d = function(arg0, arg1, arg2) {
        const ret = loadRam(getStringFromWasm0(arg1, arg2));
        var ptr1 = isLikeNone(ret) ? 0 : passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_log_196a52943e1232c9 = function(arg0, arg1) {
        console.log(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        const ret = new Error();
        return ret;
    };
    imports.wbg.__wbg_playAudioSamples_61d894a4094cbee5 = function(arg0, arg1, arg2, arg3) {
        playAudioSamples(getArrayF32FromWasm0(arg0, arg1), getArrayF32FromWasm0(arg2, arg3));
    };
    imports.wbg.__wbg_saveRTCState_c0ef1cad842806b0 = function(arg0, arg1, arg2) {
        saveRTCState(getStringFromWasm0(arg0, arg1), WasmRTCState.__wrap(arg2));
    };
    imports.wbg.__wbg_saveRam_ec7747df3e2bd940 = function(arg0, arg1, arg2, arg3) {
        saveRam(getStringFromWasm0(arg0, arg1), getArrayU8FromWasm0(arg2, arg3));
    };
    imports.wbg.__wbg_stack_0ed75d68575b0f3c = function(arg0, arg1) {
        const ret = arg1.stack;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_export_3;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
        ;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function __wbg_init_memory(imports, memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedFloat32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('retroboyCore_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
